"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeStartTime = exports.findExposeElement = exports.collectDataFromDataset = exports.resolveAppId = exports.removeUriQuery = exports.isUseNative = exports.getAppInfo = exports.isVersionCompatible = exports.isApp = exports.iOS = exports.isAndroid = void 0;
var event_tracking_core_1 = require("@al/event-tracking-core");
var constants_1 = require("../constants");
var APP_MIN_VERSION = {
    akulaku: {
        android: "3.0.63",
        ios: "3.5.0", // ios >= 3.5.0 重构
    },
    silvrrplus: {
        android: "1.0.0",
        ios: "1.0.0",
    },
};
var APP_UA_REGEXP = /(akulaku|silvrrplus)\/([\d+.]+)/;
function isAndroid() {
    return /(Android)/i.test(window.navigator.userAgent);
}
exports.isAndroid = isAndroid;
function iOS() {
    return (["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document));
}
exports.iOS = iOS;
function isApp() {
    var ua = window.navigator.userAgent;
    return /akulaku|silvrrplus/gi.test(ua);
}
exports.isApp = isApp;
function isVersionCompatible() {
    var appInfo = getAppInfo();
    if (appInfo.appName && appInfo.version) {
        var minVersions = APP_MIN_VERSION[appInfo.appName] || {};
        var ios = minVersions.ios;
        var android = minVersions.android;
        var compareVersion = isAndroid() ? android : ios;
        return appInfo.version >= compareVersion;
    }
    return false;
}
exports.isVersionCompatible = isVersionCompatible;
function getAppInfo() {
    var ua = window.navigator.userAgent;
    var matched = ua.match(APP_UA_REGEXP);
    if (matched && matched.length > 0) {
        return {
            appName: (matched[1] || ""),
            version: matched[2] || "",
        };
    }
    return {
        appName: "",
        version: "",
    };
}
exports.getAppInfo = getAppInfo;
function isUseNative(isNative) {
    // akulaku 或 silvrrplus app 内判断版本号，其他情况下不处理版本号，由业务自行决定 is_native 即可
    return (isApp() && isNative && isVersionCompatible()) || (isNative && !isApp());
}
exports.isUseNative = isUseNative;
function removeUriQuery(uri) {
    if (uri) {
        return uri.split("?")[0] || "";
    }
    return "";
}
exports.removeUriQuery = removeUriQuery;
function resolveAppId() {
    if (isAndroid()) {
        return constants_1.ANDROID_APP_ID;
    }
    if (iOS()) {
        return constants_1.IOS_APP_ID;
    }
    return constants_1.OTHER_WEB_APP_ID;
}
exports.resolveAppId = resolveAppId;
function collectDataFromDataset(element, key, recursive) {
    if (recursive === void 0) { recursive = true; }
    if (!element) {
        return;
    }
    if (element instanceof HTMLElement) {
        var dataset = element.dataset;
        var data = void 0;
        var value = dataset[key];
        if (value) {
            try {
                var parsed = JSON.parse(value);
                data = __assign(__assign({}, data), parsed);
            }
            catch (error) {
                //
            }
        }
        if (data) {
            return data;
        }
        if (!data && recursive && element.parentElement) {
            return collectDataFromDataset(element.parentElement, key);
        }
    }
}
exports.collectDataFromDataset = collectDataFromDataset;
function findExposeElement(element) {
    var _a, _b;
    if (!element) {
        return;
    }
    if (element instanceof HTMLElement) {
        var dataset = element.dataset;
        var exposeData = dataset[event_tracking_core_1.EXPOSE_DATASET_KEY];
        if (exposeData) {
            try {
                var hasV4 = (_b = (_a = JSON.parse(exposeData)) === null || _a === void 0 ? void 0 : _a.behavior) === null || _b === void 0 ? void 0 : _b.v4;
                if (hasV4) {
                    return element;
                }
            }
            catch (error) {
                return;
            }
        }
        else if (element.parentElement) {
            return findExposeElement(element.parentElement);
        }
    }
}
exports.findExposeElement = findExposeElement;
function removeStartTime(item) {
    var startTime = item.startTime, others = __rest(item, ["startTime"]);
    return __assign({}, others);
}
exports.removeStartTime = removeStartTime;
